import { X, Check } from "lucide-react";

const t = {
  fr: {
    title: "Position de Marché Unique",
    subtitle: "Redéfinir la Norme de l'Industrie",
    leftTitle: "Les concurrents fonctionnent sur d'anciennes hypothèses :",
    leftItems: [
      "Chaque traiteur a besoin de son propre site web / plateforme",
      "Les parents doivent s'adapter à chaque traiteur",
      "Les écoles sont passives",
      "Les plateformes sont isolées et désuètes",
      "Même les plateformes récentes sont copiées sur des processus inadéquats, mal pensés et répétitifs",
    ],
    rightTitle: "EcoLunch introduit le nouveau modèle :",
    rightItems: [
      "Une plateforme pour tous",
      "EcoLunch devient une marque connue et fiable pour les parents",
      "Les traiteurs bénéficient d'une UX et d'outils standards de l'industrie",
      "Les écoles gagnent en visibilité sans augmenter leur charge de travail",
      "Les parents bénéficient d'un compte transparent et transférable entre les écoles et les régions",
    ],
    conclusion: "EcoLunch est positionné pour devenir la « norme numérique officielle » des programmes de repas des écoles primaires.",
  },
  en: {
    title: "Unique Market Position",
    subtitle: "Redefining the Industry Standard",
    leftTitle: "Competitors operate on old assumptions:",
    leftItems: [
      "Each caterer needs their own website / platform",
      "Parents must adapt to each caterer",
      "Schools are passive",
      "Platforms are isolated and outdated",
      "Even recent platforms copy inadequate, poorly thought-out processes",
    ],
    rightTitle: "EcoLunch introduces the new model:",
    rightItems: [
      "One platform for all",
      "EcoLunch becomes a trusted brand for parents",
      "Caterers benefit from industry-standard UX and tools",
      "Schools gain visibility without extra workload",
      "Parents get a transparent, transferable account across schools and regions",
    ],
    conclusion: "EcoLunch is positioned to become the \"official digital standard\" for elementary school meal programs.",
  },
};

export default function MarketSection({ lang }) {
  const c = t[lang];
  return (
    <section data-testid="market-section" className="py-16 sm:py-24 bg-darker">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">{c.title}</h2>
          <p className="text-lg sm:text-xl text-white/70 px-4">{c.subtitle}</p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 mb-8 sm:mb-12">
          <div className="rounded-xl border text-card-foreground shadow bg-dark border-destructive/30">
            <div className="p-6 pt-6 sm:pt-8 pb-6 sm:pb-8">
              <div className="flex items-center gap-3 mb-6">
                <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-destructive/20 flex items-center justify-center">
                  <X className="h-5 w-5 sm:h-6 sm:w-6 text-destructive" />
                </div>
                <h3 className="text-lg sm:text-2xl font-bold text-white">{c.leftTitle}</h3>
              </div>
              <ul className="space-y-3 sm:space-y-4">
                {c.leftItems.map((item) => (
                  <li key={item} className="flex items-start gap-3">
                    <X className="h-5 w-5 text-destructive flex-shrink-0 mt-0.5" />
                    <span className="text-sm sm:text-base text-white/70">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="rounded-xl border text-card-foreground shadow bg-dark border-primary/50 glow-primary">
            <div className="p-6 pt-6 sm:pt-8 pb-6 sm:pb-8">
              <div className="flex items-center gap-3 mb-6">
                <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-primary/20 flex items-center justify-center">
                  <Check className="h-5 w-5 sm:h-6 sm:w-6 text-primary" />
                </div>
                <h3 className="text-lg sm:text-2xl font-bold text-white italic">{c.rightTitle}</h3>
              </div>
              <ul className="space-y-3 sm:space-y-4">
                {c.rightItems.map((item) => (
                  <li key={item} className="flex items-start gap-3">
                    <Check className="h-5 w-5 text-primary flex-shrink-0 mt-0.5" />
                    <span className="text-sm sm:text-base text-white font-semibold">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className="rounded-xl border text-card-foreground shadow bg-dark border-primary/50 glow-strong">
          <div className="p-6 py-6 sm:py-8">
            <p className="text-lg sm:text-xl lg:text-2xl font-bold text-white text-center px-4" style={{ textShadow: "0 0 30px rgba(182,236,19,0.6)" }}>{c.conclusion}</p>
          </div>
        </div>
      </div>
    </section>
  );
}
